import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
const Blogcard = (props) => {
  const navigation = useHistory();

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={3}
      lg={3}
      sx={{
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
        margin: "0 0 2rem 0",
      }}
    >
      <Box
        sx={{
          borderRadius: "0.8rem",
          border: ".1rem solid #e8e8ea",
          padding: "0.8rem",
          boxShadow: "0 3px 10px rgb(118 209 169 / 80%)",
          borderRadius: "18px", // Fixed typo here
        }}
      >
        {/* <Box
          sx={{
            width: { xs: "100%", sm: "14rem", md: "16rem" },
            height: { xs: "10rem", md: "11rem" },
          }}
        >      
          <img
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "0.3rem",
              objectFit: "cover",
            }}
            src={props.blogImage} 
            alt={props.blogTitle}
          />
        </Box> */}

        <Box sx={{ margin: ".5rem 0 0 0" }}>
          <Typography
            sx={{
              fontFamily: "Montserrat ,sans-serif",
              fontSize: "1.5rem",
              fontWeight: "400",
              fontStyle: "normal",
              lineHeight: "1.2",
              color: "#000",
              backgroundColor: "#ffffff",
            }}
          >
            {props.blogTitle}
          </Typography>
        </Box>

        <Box sx={{ marginTop: ".5rem", paddingBottom: "1rem" }}>
          <Typography
            sx={{
              fontFamily: "Montserrat ,sans-serif",
              fontSize: "0.9rem",
              fontWeight: "400",
              fontStyle: "normal",
              lineHeight: "1.2",
              color: "#000",
              backgroundColor: "#ffffff",
            }}
          >
            {props.blogAuthor}
            <br />
            {props.blogDate}
          </Typography>
        </Box>

        {/* <Link to={props.blogLink} style={{ textDecoration: "none" }}> */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#13706a !important",
            "&:hover": { backgroundColor: "#13706a" },
            color: "#fff !important",
            width: "100% !important",
          }}
          onClick={() => {
            navigation.push(`/${props.blogLink}`);
          }}
        >
          Read More
        </Button>
        {/* </Link> */}
      </Box>
    </Grid>
  );
};

export default Blogcard;
